import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";

import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import { CityProvider } from "@/contexts/Citycontext";
import { InstallProvider } from "@/contexts/InstallContext";
import { NotificationProvider } from "@/contexts/NotificationContext";
import IosInstallHint from "@/components/IosInstallHint";
import InstallTutorial from "@/components/InstallTutorial";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import About from "@/pages/About";
import PosterDashboard from "@/pages/PosterDashboard";
import SeekerDashboard from "@/pages/SeekerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import Notifications from "@/pages/Notifications";
import CompanyProfile from "@/pages/CompanyProfile";
import PublicCompany from "@/pages/PublicCompany";
import AuthCallback from "@/pages/AuthCallback";
import ContactPage from "./pages/Contactpage";
import BlogList, { BlogDetail } from "./pages/Blogpage";
import WhatsAppWidget from "./components/Whatsappwidget";
import WhatsAppFAQAdmin from "./components/Whatsappfaqadmin";
import ScrollToTop from "./components/ScrollToTop";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
      <CityProvider>
        <InstallProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <IosInstallHint />
            <InstallTutorial />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/jobs" element={<Layout><Jobs /></Layout>} />
              <Route path="/jobs/:id" element={<Layout><JobDetail /></Layout>} />
              <Route path="/login" element={<Layout><Login /></Layout>} />
              <Route path="/register" element={<Layout><Register /></Layout>} />
              <Route path="/about" element={<Layout><About /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/company/:cid" element={<Layout><PublicCompany /></Layout>} />
              <Route path="/notifications" element={<ProtectedRoute><Layout><Notifications /></Layout></ProtectedRoute>} />
              <Route path="/dashboard/poster/*" element={<ProtectedRoute roles={["job_poster","admin","super_admin"]}><Layout><PosterDashboard /></Layout></ProtectedRoute>} />
              <Route path="/dashboard/seeker/*" element={<ProtectedRoute roles={["job_seeker"]}><Layout><SeekerDashboard /></Layout></ProtectedRoute>} />
              <Route path="/admin/*" element={<ProtectedRoute roles={["admin","super_admin"]}><Layout><AdminDashboard /></Layout></ProtectedRoute>} />
              <Route path="/superadmin/*" element={<ProtectedRoute roles={["super_admin"]}><Layout><SuperAdminDashboard /></Layout></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </InstallProvider>
      </CityProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}